import React, { useEffect, Fragment, useState, useRef } from 'react';

import { Modal } from 'flowbite';
import pluralize from 'pluralize';

import AddInputReachCategoryModal from './partial/AddInputReachCategoryModal';
import EditInputReachCategoryModal from './partial/EditInputReachCategoryModal';

import { parseLocaleNumber } from 'Helpers/currencyFormat';
import { modalOptions } from 'Helpers/modalOptions';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';
import SimpleConfirmationModal from 'CommonComponents/SimpleConfirmationModal';
import TextButton from 'CommonComponents/TextButton';
import Tooltip from 'CommonComponents/Tooltip';

import EditIcon from 'Assets/icons/edit.svg';
import PlusCircleIcon from 'Assets/icons/plus-circle.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function InputsReachAwareness(props) {
    const [socialMediaCategories, setSocialMediaCategories] = useState([]);
    const [defaultSMObject, setDefaultSMObject] = useState({});
    const [defaultBObject, setDefaultBObject] = useState({});
    const [editCatIndex, setEditCatIndex] = useState(null);
    const [editCatName, setEditCatName] = useState('');
    const [deletedRowData, setDeletedRowData] = useState({});

    const [editInputReachCategoryModalElement, setEditInputReachCategoryModalElement] = useState(null);
    const [addInputReachCategoryModalElement, setAddInputReachCategoryModalElement] = useState(null);
    const [inputReachConfirmDeleteRowModalElement, setInputReachConfirmDeleteRowModalElement] = useState(null);

    const editInputReachCategoryModalRef = useRef();
    const addInputReachCategoryModalRef = useRef();
    const inputReachConfirmDeleteRowModalRef = useRef();

    const smColumns = ['Facebook', 'Instagram', 'Twitter', 'TikTok', 'YouTube', 'Other'];
    const bColumns = ['average_viewers', 'peak_viewers', 'total_viewers', 'nations_broadcast'];

    useEffect(() => {
        const defaultObject = {};
        smColumns.forEach((col) => {
            defaultObject[col] = 0;
        });
        setDefaultSMObject(defaultObject);

        const bDefaultObject = {};
        bColumns.forEach((col) => {
            bDefaultObject[col] = 0;
        });
        setDefaultBObject(bDefaultObject);

        socialMediaCategoriesFromProps();

        editInputReachCategoryModalRef && setEditInputReachCategoryModalElement(new Modal(editInputReachCategoryModalRef.current, modalOptions(false)));
        addInputReachCategoryModalRef && setAddInputReachCategoryModalElement(new Modal(addInputReachCategoryModalRef.current, modalOptions(false)));
        inputReachConfirmDeleteRowModalRef &&
            setInputReachConfirmDeleteRowModalElement(new Modal(inputReachConfirmDeleteRowModalRef.current, modalOptions(false)));
    }, []);

    useEffect(() => {
        socialMediaCategoriesFromProps();
    }, [props.data.social_media]);

    const socialMediaCategoriesFromProps = () => {
        const res = [];
        props.data.social_media.forEach((el, index) => {
            const category = Object.keys(el)[0];
            res.push(category);
        });

        setSocialMediaCategories(res);
    };

    const changeSNDescription = (e, category, indexCategory, indexRow) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = e.target.value;

        let categoryData = JSON.parse(JSON.stringify(data.social_media[indexCategory]));
        let row = categoryData[category][indexRow];

        row = _.mapKeys(row, (value, key) => val);
        categoryData[category][indexRow] = row;
        data.social_media[indexCategory] = categoryData;

        props.changeHandler(data);
    };

    const changeBDescription = (e, indexRow) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = e.target.value;

        let row = JSON.parse(JSON.stringify(data.broadcast[indexRow]));
        row = _.mapKeys(row, (value, key) => val);

        data.broadcast[indexRow] = row;

        props.changeHandler(data);
    };

    const changeSNInput = (e, category, indexCategory, indexRow, key, col) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = parseLocaleNumber(e.target.value);
        val = Number.isNaN(val) ? 0 : val;
        data.social_media[indexCategory][category][indexRow][key][col] = val;

        props.changeHandler(data);
    };

    const changeBInput = (e, index, key, col) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = parseLocaleNumber(e.target.value);
        val = Number.isNaN(val) ? 0 : val;
        data.broadcast[index][key][col] = val;

        props.changeHandler(data);
    };

    const addSNEntity = (e, indexCategory, category) => {
        e.preventDefault();
        const data = JSON.parse(JSON.stringify(props.data));
        const obj = {
            '': JSON.parse(JSON.stringify(defaultSMObject)),
        };

        data.social_media[indexCategory][category].push(obj);
        props.changeHandler(data);
    };

    const addBEntity = (e) => {
        e.preventDefault();
        const data = JSON.parse(JSON.stringify(props.data));
        const obj = {
            '': JSON.parse(JSON.stringify(defaultBObject)),
        };

        data.broadcast.push(obj);
        props.changeHandler(data);
    };

    const addSNCategory = (catName) => {
        const data = JSON.parse(JSON.stringify(props.data));
        const entityObj = {
            '': JSON.parse(JSON.stringify(defaultSMObject)),
        };

        const categoryObject = {
            [catName]: [entityObj],
        };

        data.social_media.push(categoryObject);
        props.changeHandler(data);
    };

    const editSNCategory = (catName) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let row = JSON.parse(JSON.stringify(data.social_media[editCatIndex]));
        row = _.mapKeys(row, (value, key) => catName);
        data.social_media[editCatIndex] = row;

        props.changeHandler(data);
    };

    const deleteRow = () => {
        const data = JSON.parse(JSON.stringify(props.data));

        const group = deletedRowData.group;
        const categoryIndex = deletedRowData.categoryIndex;
        const rowIndex = deletedRowData.rowIndex;

        if (categoryIndex === null) {
            data[group].splice(rowIndex, 1);
        } else if (rowIndex === null) {
            data[group].splice(categoryIndex, 1);
        } else {
            const obj = data[group][categoryIndex];
            const key = Object.keys(obj)[0];
            data[group][categoryIndex][key].splice(rowIndex, 1);
        }
        props.changeHandler(data);
        closeModal();
    };

    const confirmDeleteRow = (e, group, categoryIndex, rowIndex) => {
        e.preventDefault();
        setDeletedRowData({
            group,
            categoryIndex,
            rowIndex,
            entity: 'row',
        });
        inputReachConfirmDeleteRowModalElement && inputReachConfirmDeleteRowModalElement.show();
    };

    const confirmDeleteCategory = (e, group, categoryIndex) => {
        e.preventDefault();
        setDeletedRowData({
            group,
            categoryIndex,
            rowIndex: null,
            entity: 'category',
        });
        inputReachConfirmDeleteRowModalElement && inputReachConfirmDeleteRowModalElement.show();
    };

    const addCat = (e) => {
        e.preventDefault();
        addInputReachCategoryModalElement && addInputReachCategoryModalElement.show();
    };

    const editCat = (e, name, index) => {
        e.preventDefault();
        setEditCatIndex(index);
        setEditCatName(name);
        editInputReachCategoryModalElement && editInputReachCategoryModalElement.show();
    };

    const successHandler = (name) => {
        closeModal();
        addSNCategory(name);
    };
    const successEditHandler = (name) => {
        closeModal();
        editSNCategory(name);
    };

    const closeModal = () => {
        addInputReachCategoryModalElement && addInputReachCategoryModalElement.hide();
        editInputReachCategoryModalElement && editInputReachCategoryModalElement.hide();
        inputReachConfirmDeleteRowModalElement && inputReachConfirmDeleteRowModalElement.hide();
        setEditCatIndex(null);
        setEditCatName('');
        setDeletedRowData({});
    };

    return (
        <div className="table__card">
            <h2 className="table__header tw-mb-6">Reach & Awareness</h2>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th className="tw-min-w-48">
                                <div className="tw-flex tw-items-center tw-gap-x-2">
                                    <div>1. Social Media</div>
                                    <Tooltip placement="bottom" tooltipContent={$t('Add new Category')} tooltipType="text" offset={[0, 16]}>
                                        <button className="table__icon-btn small" onClick={(e) => addCat(e)}>
                                            <PlusCircleIcon className="tw-w-2.5 tw-h-2.5" />
                                        </button>
                                    </Tooltip>
                                </div>
                            </th>
                            <th className="tw-min-w-40"></th>
                            {smColumns.map((col) => {
                                return <th key={'header_' + col}>{$t(col)}</th>;
                            })}
                            <th className="tw-min-w-32">{$t('Total')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {socialMediaCategories.map((category) => {
                            let indexCat = null;
                            const categoryData = props.data.social_media.find((el, indexCategory) => {
                                if (Object.keys(el)[0] === category) {
                                    indexCat = indexCategory;

                                    return true;
                                }

                                return Object.keys(el)[0] === category;
                            });

                            if (categoryData) {
                                return (
                                    <Fragment key={'category_' + indexCat}>
                                        {categoryData[category].map((row, indexRow) => {
                                            const description = Object.keys(row)[0];
                                            let total = 0;

                                            return (
                                                <tr key={'category_' + indexCat + '_' + indexRow}>
                                                    <td>
                                                        {indexRow === 0 && (
                                                            <div className="tw-flex tw-items-center tw-gap-x-3">
                                                                <div>{category}</div>
                                                                <div className="tw-flex tw-items-center tw-gap-x-1">
                                                                    <button className="table__icon-btn small" onClick={(e) => editCat(e, category, indexCat)}>
                                                                        <EditIcon className="tw-w-2.5 tw-h-2.5" />
                                                                    </button>
                                                                    <button
                                                                        className="table__icon-btn small"
                                                                        onClick={(e) => confirmDeleteCategory(e, 'social_media', indexCat, null)}
                                                                    >
                                                                        <TrashIcon className="tw-w-2.5 tw-h-2.5" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className="tw-flex tw-items-center tw-gap-x-2">
                                                            <input
                                                                className="text-input"
                                                                type={'text'}
                                                                value={description}
                                                                placeholder={$t('Enter {{category}} name', { category: pluralize.singular(category) })}
                                                                onChange={(e) => {
                                                                    changeSNDescription(e, category, indexCat, indexRow);
                                                                }}
                                                            />
                                                            {categoryData[category].length > 1 && (
                                                                <button
                                                                    className="tw-text-red tw-shrink-0"
                                                                    onClick={(e) => confirmDeleteRow(e, 'social_media', indexCat, indexRow)}
                                                                >
                                                                    <TrashIcon className="tw-w-2.5 tw-h-2.5" />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                    {smColumns.map((col) => {
                                                        total += parseFloat(row[description][col]) ? parseFloat(row[description][col]) : 0;
                                                        return (
                                                            <td key={'category_' + indexCat + '_' + indexRow + '_' + col}>
                                                                <NumberFormat
                                                                    thousandSeparator={true}
                                                                    inputMode="numeric"
                                                                    className="text-input"
                                                                    value={row[description][col]}
                                                                    onChange={(e) => {
                                                                        changeSNInput(e, category, indexCat, indexRow, description, col);
                                                                    }}
                                                                />
                                                            </td>
                                                        );
                                                    })}
                                                    <td>{props.format(total)}</td>
                                                </tr>
                                            );
                                        })}
                                        <tr>
                                            <td></td>
                                            <td colSpan={100}>
                                                <TextButton variant="primary" onClick={(e) => addSNEntity(e, indexCat, category)}>
                                                    <PlusCircleIcon className="tw-w-3 tw-h-3" />
                                                    <div>
                                                        {$t('Add new')} {pluralize.singular(category)}
                                                    </div>
                                                </TextButton>
                                            </td>
                                        </tr>
                                    </Fragment>
                                );
                            }
                        })}
                    </tbody>
                </table>
            </div>

            <div className="inbud-table_wrapper tw-mt-4">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th className="tw-min-w-48">2. Broadcast</th>
                            <th></th>
                            {bColumns.map((col) => {
                                return <th key={'header_' + col}>{$t(_.startCase(col.replace('_', ' ')))}</th>;
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {props.data.broadcast.map((row, index) => {
                            const description = Object.keys(row)[0];

                            return (
                                <tr key={'broadcast_' + index}>
                                    <td></td>
                                    <td>
                                        <div className="tw-flex tw-gap-x-2">
                                            <input
                                                className="text-input"
                                                type={'text'}
                                                value={description}
                                                placeholder={$t('Enter broadcast name')}
                                                onChange={(e) => {
                                                    changeBDescription(e, index);
                                                }}
                                            />
                                            {props.data.broadcast.length > 1 && (
                                                <button className="tw-text-red" onClick={(e) => confirmDeleteRow(e, 'broadcast', null, index)}>
                                                    <TrashIcon className="tw-w-3 tw-h-3" />
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                    {bColumns.map((col) => {
                                        return (
                                            <td key={'broadcast_' + index + '_' + col}>
                                                <NumberFormat
                                                    thousandSeparator={true}
                                                    inputMode="numeric"
                                                    className="text-input"
                                                    value={row[description][col]}
                                                    onChange={(e) => {
                                                        changeBInput(e, index, description, col);
                                                    }}
                                                />
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                        <tr>
                            <td></td>
                            <td colSpan={100}>
                                <TextButton variant="primary" onClick={(e) => addBEntity(e)}>
                                    <PlusCircleIcon className="tw-w-3 tw-h-3" />
                                    {$t('Add new broadcast')}
                                </TextButton>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <AddInputReachCategoryModal
                modalId={'inputs-add-reach-cat'}
                modalRef={addInputReachCategoryModalRef}
                modalElement={addInputReachCategoryModalElement}
                closeHandler={closeModal}
                successHandler={successHandler}
            />
            <EditInputReachCategoryModal
                modalId={'inputs-edit-reach-cat'}
                modalRef={editInputReachCategoryModalRef}
                modalElement={editInputReachCategoryModalElement}
                name={editCatName}
                closeHandler={closeModal}
                successHandler={successEditHandler}
            />
            <SimpleConfirmationModal
                closeHandler={closeModal}
                successHandler={deleteRow}
                allowAction={Object.keys(deletedRowData).length > 0}
                modalId={'inputs-reach-delete-row'}
                modalRef={inputReachConfirmDeleteRowModalRef}
                modalElement={inputReachConfirmDeleteRowModalElement}
                confirmationMsg={'Are you sure you want to delete this ' + deletedRowData?.entity + '?'}
                title={'Delete ' + deletedRowData?.entity}
                cancelButtonText={$t('Cancel')}
                primaryButtonText={$t('OK')}
            />
        </div>
    );
}
